import auth from './auth';
// import user from './user';

// react-combine-reducers сангийн орлуулалт (гадаад сан шаардахгүй).
// Тухайн сан regenerator-runtime/core-js шаардаж build эвддэг байсан тул хассан.
// Slice бүр [reducer, initialState] хос байна — үр дүнгийн бүтэц өмнөхтэй яг ижил:
// state = { auth: {...} } тул state.auth.loggedIn гэх мэт хандалтууд хэвээрээ.
const combineReducers = (slices) => {
    const keys = Object.keys(slices);

    const combinedInitial = {};
    const reducers = {};
    keys.forEach((key) => {
        const [sliceReducer, sliceInitial] = slices[key];
        reducers[key] = sliceReducer;
        combinedInitial[key] = sliceInitial;
    });

    const combinedReducer = (state, action) => {
        let changed = false;
        const next = {};
        keys.forEach((key) => {
            const prevSlice = state ? state[key] : undefined;
            const nextSlice = reducers[key](prevSlice, action);
            next[key] = nextSlice;
            if (nextSlice !== prevSlice) changed = true;
        });
        return changed ? next : state;
    };

    return [combinedReducer, combinedInitial];
};

const [reducer, initialState] = combineReducers({
    auth,
    // user,
});

export { reducer, initialState };
